export const documenter = () => {
    let effects = {};
    return (name, steps, config, rack, component) => {
        if (name === undefined) {
            return Object.keys(effects);
        }
        if (name in effects) {
            return effects[name];
        } else if (!steps) {
            return undefined;
        }
        effects[name] = {
            component,
            steps,
            rack,
            config
        };
        return effects;
    };
};



